import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const ProjectCard = ({ project }) => {
  return (
    <div className="glass-card rounded-xl overflow-hidden flex flex-col h-full group">
      {/* Thumbnail */}
      <div className="relative h-48 overflow-hidden bg-slate-800">
        <img 
          src={project.image} 
          alt={project.title} 
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 opacity-80 group-hover:opacity-100"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900 to-transparent opacity-80"></div>
      </div>

      {/* Content */}
      <div className="p-6 flex flex-col flex-grow relative">
        {/* Tech Stack Badges */}
        <div className="flex flex-wrap gap-2 mb-4 -mt-10 relative z-10">
          {project.tags.map(tag => (
            <span key={tag} className="text-xs font-mono font-medium px-2.5 py-1 rounded bg-slate-800 border border-slate-700 text-emerald-400">
              {tag}
            </span>
          ))}
        </div>

        <h3 className="text-xl font-bold text-white mb-2 group-hover:text-emerald-400 transition-colors">
          {project.title}
        </h3>
        <p className="text-slate-400 text-sm mb-6 flex-grow">
          {project.description}
        </p>

        {/* Action Links */}
        <div className="flex items-center gap-4 mt-auto pt-4 border-t border-slate-800/50">
          {project.demoLink && (
            <a href={project.demoLink} className="text-sm font-medium text-white hover:text-emerald-400 flex items-center gap-1.5 transition-colors">
              <SafeIcon icon={FiIcons.FiExternalLink} /> Live Demo
            </a>
          )}
          {project.repoLink && (
            <a href={project.repoLink} className="text-sm font-medium text-slate-400 hover:text-white flex items-center gap-1.5 transition-colors ml-auto">
              <SafeIcon icon={FiIcons.FiGithub} /> Repo
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;